export const account_type_list = [
    {
        title: '现金',
        key: 'cash',
    },
    {
        title: '银行',
        key: 'bank',
    },
    {
        title: '支付宝',
        key: 'alipay',
    },
    {
        title: '财付通',
        key: 'wechat',
    },
]

export const cbs_type_list = [
    {
        title: 'CBS',
        key: true,
    },
    {
        title: '非CBS',
        key: false,
    },
]